import React from "react"
import { useStaticQuery, graphql } from "gatsby"
//import "../styles/monitaur.scss"
import "../styles/bulmaswatch/bulmaswatch.scss"
import "../styles/sassy.sass"

import Header from "./header"
import Footer from "./footer"
import Nav from "./nav"

export default function Layout({ children }) {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
          menuLinks {
            name
            link
          }
        }
      }
    }
  `)
  return (
    <>
      <Header menuLinks={data.site.siteMetadata.menuLinks} siteTitle={data.site.siteMetadata.title} />
      <Nav
        menuLinks={data.site.siteMetadata.menuLinks} siteTitle={data.site.siteMetadata.title}
      />
      <section className="section">
        <div className="container">
          {children}
        </div>
      </section>
      <Footer menuLinks={data.site.siteMetadata.menuLinks} siteTitle={data.site.siteMetadata.title} />
    </>
  )
}
